import Charts from "@components/charts";
import { formatTooltip } from "../misc/constants";

const OnboardingWon = ({ id, title, categories, series, height = 400, loading }) => {
    const chartOptions = {
        xAxis: {
            categories
        },
        tooltip: {
            formatter () {
                return formatTooltip({
                    date : this.x,
                    count: this.point.count,
                    value: this.point.value,
                    label: "Onboarding Won"
                });
            }
        }
    };

    return (
        <Charts
            id={id}
            type="column"
            height={height}
            categories={categories}
            loading={loading}
            series={series}
            cardHeader={{
                title,
                desc: ""
            }}
            {...chartOptions}/>
    );
};

export default OnboardingWon;
